// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VerifiedInfo-displayGrid-AP4YM {
	display: grid;
	grid-template-columns: 30px auto;
}

.VerifiedInfo-displayFlex-RNJhU {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.VerifiedInfo-infoPadding-qh8Ja {
	padding: 0px 24px 24px 24px;
}

.VerifiedInfo-tickIcon-eFdnt {
	width: 100%;
	max-width: 12px;
}

.VerifiedInfo-googleIcon-C4em6{
	width: 20px;
}

.VerifiedInfo-fbIcon-Siw9g{
	width: 15px;
}

.VerifiedInfo-emailTop-cMcH5{
	position: relative;
	top: -2px;
}`, "",{"version":3,"sources":["webpack://./src/components/VerifiedInfo/VerifiedInfo.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AACA;CACC,WAAW;AACZ;;AACA;CACC,WAAW;AACZ;;AACA;CACC,kBAAkB;CAClB,SAAS;AACV","sourcesContent":[".displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 30px auto;\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.infoPadding {\n\tpadding: 0px 24px 24px 24px;\n}\n\n.tickIcon {\n\twidth: 100%;\n\tmax-width: 12px;\n}\n.googleIcon{\n\twidth: 20px;\n}\n.fbIcon{\n\twidth: 15px;\n}\n.emailTop{\n\tposition: relative;\n\ttop: -2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayGrid": `VerifiedInfo-displayGrid-AP4YM`,
	"displayFlex": `VerifiedInfo-displayFlex-RNJhU`,
	"infoPadding": `VerifiedInfo-infoPadding-qh8Ja`,
	"tickIcon": `VerifiedInfo-tickIcon-eFdnt`,
	"googleIcon": `VerifiedInfo-googleIcon-C4em6`,
	"fbIcon": `VerifiedInfo-fbIcon-Siw9g`,
	"emailTop": `VerifiedInfo-emailTop-cMcH5`
};
module.exports = ___CSS_LOADER_EXPORT___;
